import React from "react";
import { createRoot } from "react-dom/client";
import { I18nProvider } from "@nelurio/i18n";
import "@nelurio/ui/styles.css";
import "./styles.css";
import { AdminApp } from "./AdminApp";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider defaultLocale="de-DE">
      <AdminApp />
    </I18nProvider>
  </React.StrictMode>
);
